import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { LCDocumentEditor } from './LCDocumentEditor';
import { ILectioPlugin } from './Types';

export class PluginLectioButtons implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectiobuttons', {
			init: initeditor
		});
	}
}

function initeditor(editor: CKEDITOR.editor): void {
	const cfg = LCDocumentEditorUtils.GetEditorConfig(editor);
	if (!cfg.enableLectioButtons)
		return;

	editor.addCommand('lectiosave', {
		exec: (editorInner: CKEDITOR.editor) => {

			const btn = $(".cke_button__lectiosave");

			const prm = Sys.WebForms.PageRequestManager.getInstance();

			function startAnimation() {
				btn.css({ 'background-color': '#cccccc' });
			}

			function stopAnimation() {
				btn.css({ 'background-color': '' });
				prm.remove_beginRequest(startAnimation);
				prm.remove_endRequest(stopAnimation);

				const container = $(editor.container.$);
				const backupDiv = container.parent().prev('[id*=\"backupContentDiv\"]');
				backupDiv.remove();
			}

			prm.add_beginRequest(startAnimation);
			prm.add_endRequest(stopAnimation);

			LCDocumentEditor.SaveEditorBookmark(editor);

			window.__doPostBack(cfg.postBackCtrlId_save, 'save');

			return true;
		}
	});

	if (editor.ui.addButton) {
		editor.ui.addButton('LectioSave', {
			label: 'Gem (' + cfg.savebuttonKeyboardShortcut + ')',
			command: 'lectiosave',
			icon: CKEDITOR.skin.icons.save!.path,
			toolbar: ''
		});
	}


	editor.addCommand('lectioviewmode', {
		exec: editor => {
			window.__doPostBack(cfg.postBackCtrlId_viewmode, 'viewmode');
			return true;
		}
	});

	if (editor.ui.addButton) {
		editor.ui.addButton('LectioViewMode', {
			label: 'Læs (' + cfg.readbuttonKeyboardShortcut + ')',
			command: 'lectioviewmode',
			icon: CKEDITOR.skin.icons.viewmode!.path,
			toolbar: ''
		});
	}

	editor.addCommand('showdatabasemarkup', {
		exec: (editor) => {
			const editorConfig = LCDocumentEditorUtils.GetEditorConfig(editor);
			if (!editorConfig.assistedCommand)
				throw new Error('Assistedcommand er ikke sat i config.');
			editorConfig!.assistedCommand('showdatabasemarkup');

			return true;
		}
	});


}

